import styled from 'styled-components';

import { createColumnHelper } from '@tanstack/react-table';

import { simpleDateAtTime } from 'lib/date';
import Workflow from 'models/Workflow';
import { colors } from 'styles/theme/colors';
import { BodySmall } from 'styles/typography';

import { WorkflowStatusBadge } from './StatusBadge';

const columnHelper = createColumnHelper<Workflow>();

function progressLabel(workflow: Workflow): string {
  const { completed, total } = workflow.progress;
  if (total === 0) return '—';
  return `${completed} of ${total} steps`;
}

const inboundReferralsTableColumns = () => [
  columnHelper.accessor((row) => row.patientName, {
    id: 'patientName',
    header: 'Patient',
    cell: (info) => <Strong>{info.getValue()}</Strong>,
    size: 200,
    enableSorting: false,
  }),
  columnHelper.accessor((row) => row.groupNames.join(', '), {
    id: 'building',
    header: 'Building',
    cell: (info) => info.getValue() || '—',
    size: 180,
    enableSorting: false,
  }),
  columnHelper.accessor((row) => row.status, {
    id: 'status',
    header: 'Status',
    cell: (info) => (
      <StatusCell>
        <WorkflowStatusBadge status={info.row.original.status} />
        {info.row.original.hasOutcome && <Outcome>{info.row.original.outcome}</Outcome>}
      </StatusCell>
    ),
    size: 180,
    enableSorting: false,
  }),
  columnHelper.accessor((row) => progressLabel(row), {
    id: 'progress',
    header: 'Progress',
    cell: (info) => info.getValue(),
    size: 120,
    enableSorting: false,
  }),
  columnHelper.accessor((row) => row.createdAt, {
    id: 'createdAt',
    header: 'Received',
    cell: (info) => (info.getValue() ? simpleDateAtTime(info.getValue() as Date) : '—'),
    size: 160,
    enableSorting: false,
  }),
];

export default inboundReferralsTableColumns;

const Strong = styled.span`
  font-weight: 700;
  color: ${colors.black};
`;

const StatusCell = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

const Outcome = styled(BodySmall)`
  text-transform: capitalize;
  color: ${colors.primaryBlue};
  font-weight: 700;
`;
